"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBriteCheckout1Schema = void 0;
exports.EventBriteCheckout1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/eventbrite/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EventBriteCheckout1",
    "description": "Embed an EventBrite checkout form",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:eventbrite:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "eventId": {
                    "type": "string",
                    "description": "The ID of an EventBrite Event"
                }
            },
            "required": [
                "eventId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9ldmVudGJyaXRlLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEseUJBQXlCLEdBQUc7SUFDdkMsS0FBSyxFQUFFLCtFQUErRTtJQUN0RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxxQkFBcUI7SUFDOUIsYUFBYSxFQUFFLG1DQUFtQztJQUNsRCxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sdUNBQXVDO2FBQ3hDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsK0JBQStCO2lCQUMvQzthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFNBQVM7YUFDVjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9